import React, { useState, useEffect } from 'react';
//import axios from 'axios';
import MainNavbar from '../../../Components/Navbars/MainNavbar';
import Footer from '../../../Components/Footer';
import { Container, Row, Col, Modal, Button } from 'react-bootstrap';
import getEnvConfig from "../../../config";
import { MapContainer, TileLayer, Marker, Popup, useMap, GeoJSON } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';



const SearchChargingStations = () => {

  
  const { backendUrl } = getEnvConfig();
  //const [chargerLoc, setChargerLoc] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [portsAtLocation, setPortsAtLocation] = useState([]);


  //const [chargerLoc, setChargerLoc] = useState(null);
  

  const greenMarker = new L.Icon({
    iconUrl: "/images/Gps-green.png",        
    iconColor: 'green',
    iconSize: [20, 30],
    iconAnchor: [10, 41],
    popupAnchor: [2, -40]
  });

  const redMarker = new L.Icon({
    iconUrl: "/images/Gps-red.png",        
    iconColor: 'red',
    iconSize: [20, 30],
    iconAnchor: [10, 41],
    popupAnchor: [2, -40]
  });

  const yellowMarker = new L.Icon({
    iconUrl: "/images/Gps-yellow.png",        
    iconColor: 'yellow',
    iconSize: [20, 30],
    iconAnchor: [10, 41],
    popupAnchor: [2, -40]
  });

  const blueMarker = new L.Icon({
    iconUrl: "/images/Gps-blue.png",     
    iconColor: 'blue',
    iconSize: [20, 30],
    iconAnchor: [10, 41],
    popupAnchor: [2, -40]
  });

  function LocationMarker() {
    const [position, setPosition] = useState(null);
    

    const map = useMap();

    const customMarker = new L.Icon({
        iconUrl: "/images/Gps-blue.png",     
        iconcolor: 'red',
        iconSize: [20, 30],
        iconAnchor: [10, 41],
        popupAnchor: [2, -40]
      });

    useEffect(() => {
      /*alert('I am here : Locate')*/
      map.locate().on("locationfound", function (e) {
        setPosition(e.latlng);
        map.flyTo(e.latlng, map.getZoom());
      });
    }, [map]);

    return position === null ? null : (
      <Marker position={position} icon={customMarker}>
        <Popup>You are here</Popup>
      </Marker>
    );
  };


  // This function binds a popup to each feature
  function onEachFeature(feature, layer) {
    if (feature.properties && feature.properties.location_id) {
      // Assuming you want to create a link to a URL that includes the location_id
      alert(feature.properties.location_id)
      /*const url = `/charger?chargerid=${feature.properties.location_id}`;*/
      const url = `/charger/${feature.properties.location_id}`;
      layer.bindPopup(`<a href="${url}" ${feature.properties.location_id}</a>`);
    }
  }

  // Helper to get marker based on port status
  const getMarkerForStatus = (status) => {
    if (!status) return greenMarker;
    status = status.toLowerCase();
    if (status === 'available') return greenMarker;
    if (status === 'charging' || status === 'occupied' || status === 'busy') return yellowMarker;
    if (status === 'offline' || status === 'faulted') return redMarker;
    return greenMarker;
  };

  // Group ports by location
  const groupPortsByLocation = (features) => {
    if (!features) return {};
    const locationGroups = {};
    features.forEach(feature => {
      const { loc_id } = feature.properties;
      if (!locationGroups[loc_id]) locationGroups[loc_id] = [];
      locationGroups[loc_id].push(feature);
    });
    return locationGroups;
  };

  function ChargerLocationMarker() {
    const [chargerLoc, setChargerLoc] = useState(null);
    const map = useMap();
    useEffect(() => {
      map.locate().on("locationfound", function (e) {
        const { lat, lng } = e.latlng;
        const fetchData = async () => {
          try {
            const response = await fetch(backendUrl+`/chargers/listings/${lng},${lat}`, { method: "GET" });
            const reply = await response.json();        
            if (response.ok) setChargerLoc(reply['chargers']);
          } catch (error) {}
        };
        fetchData();
      });
    }, [map]);

    if (!chargerLoc) return null;
    const locationGroups = groupPortsByLocation(chargerLoc.features);

    return (
      <>
        <GeoJSON 
          data={chargerLoc} 
          pointToLayer={(feature, latlng) => {
            const locId = feature.properties.loc_id;
            const isMultiPort = locationGroups[locId] && locationGroups[locId].length > 1;
            const status = feature.properties.port_status;
            const marker = L.marker(latlng, { 
              icon: getMarkerForStatus(status),
              locationData: {
                locId,
                isMultiPort,
                ports: locationGroups[locId]
              }
            });
            if (!isMultiPort) {
              const popupContent = `
                <div>
                  <h6>Port #${feature.properties.port_number}</h6>
                  <p>Connector: ${feature.properties.connector_type_name || 'Unknown'}</p>
                  <p>Power: ${feature.properties.max_power_kw || 'N/A'} kW</p>
                  <p>Status: ${feature.properties.port_status || 'Unknown'}</p>
                  <a href="/charger/port/${feature.properties.port_id}" class="btn btn-primary btn-sm">View Charger</a>
                </div>
              `;
              marker.bindPopup(popupContent);
            } else {
              marker.on('click', function() {
                setSelectedLocation({
                  id: locId,
                  latitude: feature.properties.latitude,
                  longitude: feature.properties.longitude
                });
                setPortsAtLocation(locationGroups[locId]);
                setShowModal(true);
              });
              const popupContent = `
                <div>
                  <strong>Multiple Ports Available</strong>
                  <p>Click to view options</p>
                </div>
              `;
              marker.bindPopup(popupContent);
            }
            return marker;
          }}
        />
        {/* Modal for multi-port locations */}
        <Modal show={showModal} onHide={() => setShowModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>Available Ports at Location</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {portsAtLocation.map((feature, idx) => (
              <div key={idx} className="mb-2 p-2 border rounded">
                <div><strong>Port #{feature.properties.port_number}</strong></div>
                <div>Connector: {feature.properties.connector_type_name || 'Unknown'}</div>
                <div>Power: {feature.properties.max_power_kw || 'N/A'} kW</div>
                <div>Status: {feature.properties.port_status || 'Unknown'}</div>
                <a href={`/charger/port/${feature.properties.port_id}`} className="btn btn-primary btn-sm mt-1">View Charger</a>
              </div>
            ))}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModal(false)}>Close</Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }

  return (
    <Container fluid={true}>
      <MainNavbar />
      <Row>
        <Col className="container col-xxl-8 px-3 py-3 d-flex align-items-center justify-content-center">
        
          <span className="text-center">
            <h4>Search for Charging Stations</h4>
            <p>Find and book the nearest EV charging stations available in your area.</p>
          </span>
        </Col>
      </Row>
      <Row>
        <div className="container col-xxl-8 px-3 py-3 d-flex align-items-center justify-content-center" style={{ height: '600px', width: '100%' }}>
          <MapContainer
            center={[37, -95.7]}
            zoom={9}
            maxZoom={19}
            scrollWheelZoom
            style={{ height: "600px", width: "100%" }}
            className="custom-map-container"
          >
            <TileLayer
              attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <LocationMarker />
            <ChargerLocationMarker />
          </MapContainer>
        </div>
      </Row>
      <Footer />
    </Container>
  );
};

export default SearchChargingStations;
